var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.filteredTours.length > 0)?_c('div',[_c('span',{staticClass:"asButton"},[_c('strong',[_vm._v(_vm._s(_vm.filteredTours.length))]),_vm._v(" Tours Available ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }